import React, { useEffect, useRef, useState } from 'react';
import { nanoid } from 'nanoid';

/**
 * Renders the children and determines how many of the children will fit in the parent
 * The number that will fit is returned to the parent in a broadcast channel
 * The parent can use this information to change it's rendering
 *
 * @param {object} options - The options for fitting the children.
 * @param {ReactNode} options.children - The children elements to fit.
 * @param {number} options.gap - The gap between each child element.
 *
 * @returns {ReactElement} - The wrapped children elements within a hidden container.
 */
import { jsx as _jsx } from "react/jsx-runtime";
function FitWithinWidth(_ref) {
  let {
    children,
    gap,
    channelId
  } = _ref;
  const containerRef = useRef(null);
  const [fittingChildrenCount, setFittingChildrenCount] = useState(0);
  const itemsRef = [];
  const broadcastChannel = new BroadcastChannel(channelId);
  useEffect(() => {
    if (containerRef.current && containerRef.current.parentElement) {
      const parentWidth = containerRef.current.parentElement.offsetWidth;
      let currentWidth = 0;
      let count = 0;
      for (let i = 0; i < itemsRef.length; i++) {
        const childWidth = itemsRef[i].offsetWidth + gap;
        if (currentWidth + childWidth < parentWidth) {
          currentWidth += childWidth;
          count++;
        } else {
          break;
        }
      }
      setFittingChildrenCount(count);
      broadcastChannel.postMessage({
        fittingChildrenCount: count
      });
    }
  }, [children]);
  const wrappedChildren = React.Children.toArray(children).map(c => {
    return /*#__PURE__*/_jsx("div", {
      style: {
        display: 'hidden',
        position: 'absolute',
        left: '-9999px'
      },
      ref: el => itemsRef.push(el),
      children: c
    }, nanoid());
  });
  return /*#__PURE__*/_jsx("div", {
    style: {
      display: 'hidden',
      position: 'absolute',
      left: '-9999px'
    },
    ref: containerRef,
    className: "ids-fit-within-child-container",
    id: 'ids-fit-within-child-container',
    children: wrappedChildren
  });
}
export default FitWithinWidth;